// extracted by mini-css-extract-plugin
export default {"button":"button___krQ2onM"};